import React, { useState, useEffect, lazy, Suspense } from "react";
import "./App.css";
import "./NFT/nft.css";
import "./Bithappier.css";
import "./Marketplace/CSS/marketplace.css";
import "./NFT/CSS/practitioner.css";
import "./community/css/publicProfile.css";
import "./Userorofile/CSS/walletpage.css";
import "./community/css/communitydetail.css";
import "./community/css/community.css";
import "./Component/grparttherapy.css";
import "./Component/Therapy.css";
import "./Component/TherapyMemberList.css";
import "./Component/MeetupsCard.css";
import "./Component/Homepage.css";
import "./Component/HappinessDataTab.css";
import "./Component/HappinessData.css";
import "./Component/chatbot.css";
import "./Component/DashboardHeader.css";
import "./Component/EnjoyArtTherapy.css";
import "./Component/adminconsole.css";
import "./Component/AdminDashboard.css";
import "./Component/AIselfcare.css";
// import "./Component/BookAppointment.css";
import "./Professionals/Professionals.css";
import "./happinessgoal/CSS/happinesscontent.css";
import "./happinessgoal/CSS/homepage.css";
import "./stripe/stripe.css";
import "./Loader/loader.css";
import "./videocall/videocall.css";
import "./pages/CSS/otp.css";
import "./pages/CSS/login.css";
import "./pages/CSS/style.css";
import "./pages/CSS/Fitbit.css";
import "./pages/CSS/Congrats.css";
import "./pages/CSS/dashboard.css";
import "./pages/CSS/Existwallet.css";
import "./pages/CSS/Inputassessment.css";
import "./pages/CSS/ForgetPassword.css";
import "./pages/CSS/MriData.css";
import "./pages/CSS/Mricenter.css";
import "./pages/CSS/Smileres.css";
import "./pages/CSS/seeyourresult.css";
import "./pages/CSS/Recordinput.css";
import "./pages/CSS/privacypolicy.css";
import "./pages/CSS/verifyotp.css";
import "./pages/CSS/UserProfile.css";
import "./pages/CSS/termsandcondition.css";
import "./Component/Reusable cards/CSS/footer.css";
import "./Component/Reusable cards/recommandedactivity.css";
import "./Component/Reusable cards/RecomendedCards.css";
import "./Component/Landingpage/Components/CSS1/footer.css";
// import "./Component/Landingpage/Components/CSS1/team.css";
// import "./Component/Landingpage/Components/CSS1/strategicpartner.css";
import "./Component/Landingpage/Components/CSS1/Tokenomics.css";
// import "./Component/Landingpage/Components/CSS1/roadmap.css";
// import "./Component/Landingpage/Components/CSS1/ourvision.css";
// import "./Component/Landingpage/Components/CSS1/Navbar.css";
// import "./Component/Landingpage/Components/CSS1/Ibithappier.css";
// import "./Component/Landingpage/Components/CSS1/Launchingsoon.css";
// import "./Component/Landingpage/Components/CSS1/bithappierdo.css";
import "./Component/HappinessProfile/CSS/HappinessProfile.css";
import "./Component/NewHappinessProfile/FirstHappinessProfile.css";
import "./Component/BookAppointmentfirst.css";
import "./Component/ChatBotAI/CSS/mainselfhelp.css";
import "./Userorofile/CSS/redeempage.css";
import "./Corporate/CSS/corporatedashboard.css";
import "./Corporate/CSS/Survey.css";
import "./AI Chatbot/CSS/CBTHelp.css";
import "./Corporate/CSS/sessionfeedback.css";
import "./AI Chatbot/CSS/SelfcareCardPage.css";
import "./Component/Appointconfirmation.css";
import "./Component/ChatBotAI/CSS/aichatbot.css";
import "./Corporate/corporateaddmember.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import axios from "axios";
import { APIURI, apiConfig } from "./config";
import {
  happinessResChange,
  followersChange,
  LogInCall,
  ProfileImageContext,
  userNameContext,
  videoCallContext,
  rtcPropsContext,
  bithappierWalletContext,
  isProfileCompleteContext,
  mentalHappinessResponseContext,
  completePercentageContext,
  walletBalanceContext,
  usdAmountContext,
} from "./Context/HappinessResChange";
import { happinessGoalChange } from "./Context/HappinessResChange";
import Cookies from "universal-cookie";
import { RotatingLines } from "react-loader-spinner";
// import RewardPage from "./pages/HappinessRecommendation.js";
// import HappinessRecommendation from "./pages/HappinessRecommendation.js";
// import MeetupCard from "./Component/HappinessMeetupCard.js";
import "./happinessgoal/CSS/AiImgGenPopup.css";
import MeetUp from "./Component/Meetup.js";
import ContactUs from "./Component/ContactUs.js";
import Fundraiser from "./Component/Fundraiser.js";
import Ticket from "./Component/Ticket.js";
// import CorporateAddMember from './Corporate/CorporateAddMember.js';
// import CBTHelpDyanmic from "./AI Chatbot/CBTHelpDyanmic.js";
// import StakeBHT from "./pages/StakeBHT";
// import Home from "../src/Component/Home";
// import Login from "./pages/Login";
// import Signup from "./pages/Signup";
// import Assessment from "./pages/Assessment";
// import Questionaire from "./pages/Questionaire";
// import MriData from "./pages/MriData";
// import VerifyOtp from "./pages/VerifyOtp";
// import Fitbit from "./pages/Fitbit";
// import HappinessProfile from "./Component/HappinessProfile/HappinessProfile";
// import Mricenters from "./pages/Mricenters";
// import Conncetwallet from "./pages/Conncetwallet";
// import Createwallet from "./pages/Createwallet";
// import Existwallet from "./pages/Existwallet";
// import BuyBHT from "./pages/BuyBHT";
// import StakeBTHSummary from "./pages/StakeBTHSummary";
// import WalletAuthorisation from "./pages/WalletAuthorisation";
// import Congrats from "./pages/Congrats";
// import Smileres from "./pages/Smileres";
// import ForgetPasswordPhase1 from "./pages/ForgetPasswordPhase1";
// import ForgetPasswordPhase2 from "./pages/ForgetPasswordPhase2";
// import PaymentGateway from "./pages/PaymentGateway";
// import Recordinput from "./pages/Recordinput";
// import Termsandcondition from "./pages/Termsandcondition";
// import Privacypolicy from "./pages/Privacypolicy";
// import SeeYourResult from "./pages/SeeYourResult";
// import Inputassessment from "./pages/Inputassessment";
// import WalletPage from "./Userorofile/WalletPage";
// import Tokenomics from "./Component/Landingpage/Components/Tokenomics";
// import RecomendedCards from "./Component/Reusable cards/RecomendedCards";
// import Community from "./community/Community";
// import Latestthread from "./community/Latestthread";
// import Communitydetail from "./community/Communitydetail";
// import Popular from "./community/Popular";
// import Homepage from "./happinessgoal/Homepage";
// import Most_thread from "./community/Most_thread";
// import PublicProfilePage from "./community/PublicProfilePage";
// import Most_Liked from "./community/Most_liked";
// import Goaldetail from "./happinessgoal/Goaldetail";
// import HappinessContent from "./happinessgoal/HappinessContent";
// import Myprofile from "./NFT/Myprofile";
// import Practitioners from "./NFT/Practitioners";
// import LeaderBoard from "./NFT/profile/LeaderBoard";
// import BookAppointment from "./NFT/BookAppointment";
// import AllArttherapist from "./NFT/AllArttherapist";
// import PractitionersDetails from "./NFT/PractitionersDetails";
// import YourAppointments from "./NFT/profile/YourAppointments";
// import Journalling from "./recommended activites/Journalling";
// import Psychotherapy from "./recommended activites/Psychotherapy";
// import PhysicalActivity from "./recommended activites/PhysicalActivity";
// import ArtGallery from "./recommended activites/ArtGallery";
// import BuyingArt from "./recommended activites/BuyingArt";
// import DigitalDetox from "./recommended activites/DigitalDetox";
// import Walking from "./recommended activites/Walking";
// import GoalSetting from "./recommended activites/GoalSetting";
// import Sleep from "./recommended activites/Sleep";
// import FamilyTherapy from "./recommended activites/FamilyTherapy";
// import PositiveAttitude from "./recommended activites/PositiveAttitude";
// import EditPassword from "./pages/EditPassword";
// import Marketplace from "./Marketplace/Marketplace";
// import ExploreMarketplace from "./Marketplace/ExploreMarketplace";
// import VideoCall from "./videocall/VideoCall";
// import DigitalAuction from "./Marketplace/DigitalAuction";
// import PhysicalDirectSale from "./Marketplace/PhysicalDirectSale";
// import ShippingAddress from "./Marketplace/ShippingAddress";
// import ConfirmAddress from "./Marketplace/ConfirmAddress";
// import DirectList from "./Marketplace/DirectList";
// import ProfessionalDashboard from "./Professionals/ProfessionalDashboard";
// import MyProfilePractitionres from "./NFT/MyProfilePractitionres";
// import VideoCallTherapist from "./videocall/VideoCallTherapist";
// import Happinessresearch from "./Component/Happinessresearch";
// import Faq from "./Component/Faq";
// import AboutUsPage from "./Component/AboutUsPage";
// import CrisisHelpline from "./Component/CrisisHelpline";
// import ForOrganizations from "./Component/ForOrganizations";
// import HomeHappinessNews from "./happinessgoal/HomeHappinessNews";
// import HappinessNewsdetail from "./happinessgoal/HappinessNewsdetail";
// import Index from "./stripe/Index";
// import SuccessPage from "./stripe/SuccessPage";
// import Notification from "./NFT/profile/Notifications";
// import OpenReport from "./pages/OpenReport";
// import VerifyEmail from "./pages/VerifyEmail";
// import WalletImportThroughEmail from "./Userorofile/WalletImportThroughEmail";
// import AllHappinessBlogs from "./happinessgoal/AllHappinessBlogs";
// import AdminConsole from "./Component/AdminConsole";
// import AdminDashboard from "./Component/AdminDashboard.js";
// import EnjoyArtTherapypage from "./Component/EnjoyArtTherapypage.js";
// import TherapyMemberList from "./Component/TherapyMemberList.js";
// import Dashboard from "./pages/Dashboard";

const StakeBHT = lazy(() => import("./pages/StakeBHT"));
const Home = lazy(() => import("../src/Component/Home"));
const HomeV2 = lazy(() => import("../src/Component/HomeV2"));
const Login = lazy(() => import("./pages/Login"));
const Demo = lazy(() => import("./pages/Demo"));

const Signup = lazy(() => import("./pages/Signup"));
const Assessment = lazy(() => import("./pages/Assessment"));
const Questionaire = lazy(() => import("./pages/Questionaire"));
const MriData = lazy(() => import("./pages/MriData"));
const VerifyOtp = lazy(() => import("./pages/VerifyOtp"));
const Fitbit = lazy(() => import("./pages/Fitbit"));
const HappinessProfile = lazy(() =>
  import("./Component/HappinessProfile/HappinessProfile")
);
const Mricenters = lazy(() => import("./pages/Mricenters"));
const Conncetwallet = lazy(() => import("./pages/Conncetwallet"));
const Createwallet = lazy(() => import("./pages/Createwallet"));
const Existwallet = lazy(() => import("./pages/Existwallet"));
const BuyBHT = lazy(() => import("./pages/BuyBHT"));
const StakeBTHSummary = lazy(() => import("./pages/StakeBTHSummary"));
const WalletAuthorisation = lazy(() => import("./pages/WalletAuthorisation"));
const Congrats = lazy(() => import("./pages/Congrats"));
const Smileres = lazy(() => import("./pages/Smileres"));
const ForgetPasswordPhase1 = lazy(() => import("./pages/ForgetPasswordPhase1"));
const ForgetPasswordPhase2 = lazy(() => import("./pages/ForgetPasswordPhase2"));
const PaymentGateway = lazy(() => import("./pages/PaymentGateway"));
const Recordinput = lazy(() => import("./pages/Recordinput"));
const Termsandcondition = lazy(() => import("./pages/Termsandcondition"));
const DeleteYourAccount = lazy(() => import("./pages/DeleteYourAccount"));
const Privacypolicy = lazy(() => import("./pages/Privacypolicy"));
const SeeYourResult = lazy(() => import("./pages/SeeYourResult"));
const Inputassessment = lazy(() => import("./pages/Inputassessment"));
const WalletPage = lazy(() => import("./Userorofile/WalletPage"));
const BuyNear = lazy(() => import("./Userorofile/BuyNear.js"));
const Tokenomics = lazy(() =>
  import("./Component/Landingpage/Components/Tokenomics")
);
const RecomendedCards = lazy(() =>
  import("./Component/Reusable cards/RecomendedCards")
);
const Community = lazy(() => import("./community/Community"));
const Latestthread = lazy(() => import("./community/Latestthread"));
const Communitydetail = lazy(() => import("./community/Communitydetail"));
const Popular = lazy(() => import("./community/Popular"));
const Homepage = lazy(() => import("./happinessgoal/Homepage"));
const Most_thread = lazy(() => import("./community/Most_thread"));
const PublicProfilePage = lazy(() => import("./community/PublicProfilePage"));
const Most_Liked = lazy(() => import("./community/Most_liked"));
const Goaldetail = lazy(() => import("./happinessgoal/Goaldetail"));
const HappinessContent = lazy(() => import("./happinessgoal/HappinessContent"));
const Myprofile = lazy(() => import("./NFT/Myprofile"));
const Practitioners = lazy(() => import("./NFT/Practitioners"));
const LeaderBoard = lazy(() => import("./NFT/profile/LeaderBoard"));
const BookAppointment = lazy(() => import("./NFT/BookAppointment"));
const AllArttherapist = lazy(() => import("./NFT/AllArttherapist"));
const PractitionersDetails = lazy(() => import("./NFT/PractitionersDetails"));
const YourAppointments = lazy(() => import("./NFT/profile/YourAppointments"));
const Journalling = lazy(() => import("./recommended activites/Journalling"));
const Psychotherapy = lazy(() =>
  import("./recommended activites/Psychotherapy")
);
const PhysicalActivity = lazy(() =>
  import("./recommended activites/PhysicalActivity")
);
const ArtGallery = lazy(() => import("./recommended activites/ArtGallery"));
const BuyingArt = lazy(() => import("./recommended activites/BuyingArt"));
const DigitalDetox = lazy(() => import("./recommended activites/DigitalDetox"));
const Walking = lazy(() => import("./recommended activites/Walking"));
const GoalSetting = lazy(() => import("./recommended activites/GoalSetting"));
const Sleep = lazy(() => import("./recommended activites/Sleep"));
const FamilyTherapy = lazy(() =>
  import("./recommended activites/FamilyTherapy")
);
const PositiveAttitude = lazy(() =>
  import("./recommended activites/PositiveAttitude")
);
const EditPassword = lazy(() => import("./pages/EditPassword"));
const Marketplace = lazy(() => import("./Marketplace/Marketplace"));
const ExploreMarketplace = lazy(() =>
  import("./Marketplace/ExploreMarketplace")
);
const VideoCall = lazy(() => import("./videocall/VideoCall"));
const DigitalAuction = lazy(() => import("./Marketplace/DigitalAuction"));
const PhysicalDirectSale = lazy(() =>
  import("./Marketplace/PhysicalDirectSale")
);
const ShippingAddress = lazy(() => import("./Marketplace/ShippingAddress"));
const ConfirmAddress = lazy(() => import("./Marketplace/ConfirmAddress"));
const DirectList = lazy(() => import("./Marketplace/DirectList"));
const ProfessionalDashboard = lazy(() =>
  import("./Professionals/ProfessionalDashboard")
);
const MyProfilePractitionres = lazy(() =>
  import("./NFT/MyProfilePractitionres")
);
const VideoCallTherapist = lazy(() => import("./videocall/VideoCallTherapist"));
const Happinessresearch = lazy(() => import("./Component/Happinessresearch"));
const Faq = lazy(() => import("./Component/Faq"));
const AboutUsPage = lazy(() => import("./Component/AboutUsPage"));
const CrisisHelpline = lazy(() => import("./Component/CrisisHelpline"));
const WellNessProfessionalJoin = lazy(() => import("./Component/WellNessProfessionalJoin"));
const ForOrganizations = lazy(() => import("./Component/ForOrganizations"));
const HomeHappinessNews = lazy(() =>
  import("./happinessgoal/HomeHappinessNews")
);
const HappinessNewsdetail = lazy(() =>
  import("./happinessgoal/HappinessNewsdetail")
);
const Index = lazy(() => import("./stripe/Index"));
const BuyNearViaStripe = lazy(() => import("./Userorofile/BuyNearViaStripe"));
const BookAppointmentViaStripe = lazy(() => import("./Userorofile/BookAppointmentViaStripe"));
const SuccessPage = lazy(() => import("./stripe/SuccessPage"));
const PaymentConfirmation = lazy(() =>
  import("./Corporate/PaymentConfirmation.js")
);
const Notification = lazy(() => import("./NFT/profile/Notifications"));
const OpenReport = lazy(() => import("./pages/OpenReport"));
const VerifyEmail = lazy(() => import("./pages/VerifyEmail"));
const WalletImportThroughEmail = lazy(() =>
  import("./Userorofile/WalletImportThroughEmail")
);
const AllHappinessBlogs = lazy(() =>
  import("./happinessgoal/AllHappinessBlogs")
);
const AllHappinessNews = lazy(() => import("./happinessgoal/AllHappinessNews"));
const AdminConsole = lazy(() => import("./Component/AdminConsole"));
const AdminDashboard = lazy(() => import("./Component/AdminDashboard.js"));
const EnjoyArtTherapypage = lazy(() =>
  import("./Component/EnjoyArtTherapypage.js")
);
const TherapyMemberList = lazy(() =>
  import("./Component/TherapyMemberList.js")
);
const Dashboard = lazy(() => import("./pages/Dashboard"));
const HappinessMeetupCard = lazy(() =>
  import("./Component/HappinessMeetupCard.js")
);
const RewardPage = lazy(() => import("./pages/RewardPage.js"));
const HappinessRecommendation = lazy(() =>
  import("./pages/HappinessRecommendation.js")
);
const SelfHelp = lazy(() => import("./Component/ChatBotAI/SelfHelp.js"));
const RedeemRewardPage = lazy(() =>
  import("./Userorofile/RedeemRewardPage.js")
);
const CorporateDashboard = lazy(() =>
  import("./Corporate/CorporateDashboard.js")
);
const SelectPreferredSurvey = lazy(() =>
  import("./Corporate/SelectPreferredSurvey.js")
);
const GroupSessionFeedback = lazy(() =>
  import("./Corporate/GroupSessionFeedback.js")
);
const AfterSessionFeedback = lazy(() =>
  import("./Corporate/AfterSessionFeedback.js")
);
const CBTHelp = lazy(() => import("./AI Chatbot/CBTHelp.js"));
const SelfCare = lazy(() => import("./AI Chatbot/SelfCare.js"));
const BreathingExercise = lazy(() =>
  import("./AI Chatbot/selfcare card pages/BreathingExercise.js")
);
const ProgressiveMuscleRelaxation = lazy(() =>
  import("./AI Chatbot/selfcare card pages/ProgressiveMuscleRelaxation.js")
);
const ImageryExercise = lazy(() =>
  import("./AI Chatbot/selfcare card pages/ImageryExercise.js")
);
const Thought = lazy(() => import("./AI Chatbot/Thought.js"));
const Behaviour = lazy(() => import("./AI Chatbot/Behaviour.js"));
const Psychoeducation = lazy(() => import("./AI Chatbot/Psychoeducation.js"));
const UnhelpfulThinkingStyle = lazy(() =>
  import("./AI Chatbot/UnhelpfulThinkingStyle.js")
);
const CBTHelpDyanmic = lazy(() => import("./AI Chatbot/CBTHelpDyanmic.js"));
const SelfcareCardPage = lazy(() =>
  import("./AI Chatbot/SelfcareDynamicPage.js")
);
const Questionnaire = lazy(() =>
  import("./Component/NewHappinessProfile/Questionnaire.js")
);
const AppointmentConfirmationPage = lazy(() =>
  import("./Component/AppointmentConfirmationPage.js")
);
const CorporateLogin = lazy(() => import("./Corporate/CorporateLogin.js"));
const CorporateSignup = lazy(() => import("./Corporate/CorporateSignup.js"));
const CorporateJoinus = lazy(() => import("./Corporate/CorporateJoinus.js"));
const AiChatbot = lazy(() => import("./Component/ChatBotAI/AiChatbot.js"));
const CorporateAddMember = lazy(() =>
  import("./Corporate/CorporateAddMember.js")
);
const Subscription = lazy(() => import("./Corporate/Subscription.js"));
// import Navbarheader from "./Component/Landingpage/Components/Navbarheader";
// import UserProfile from './pages/UserProfile';
// import PrivacyPolicy from "./Component/Landingpage/PrivacyPolicy";
// import Happinessdetail from "./happinessgoal/Happinessdetail";
// import { Box } from "@mui/system";
// import CryptoJS from "crypto-js";
// import HappinessData from "./Component/HappinessData.js";
// import Home from "./Component/Landingpage/Components/Home";
// import happier from "./images/Frame.png";
// import Footer from "./Component/FooterHome";
// import Modal from "./pages/Dashboard";
// import Loader from "./Loader/Loader.js";
// import Fitnessdata from "./pages/Fitnessdata";
const nearAPI = require("near-api-js");

function App() {
  const [happinessResChan, setHappinessResChan] = useState(0);
  const [happinessGoalChan, setHappinessGoalChan] = useState(0);
  const [followersChan, setFollowersChan] = useState(0);
  const [userName, setUserName] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [loggedIn, setLoggedIn] = useState(0);
  const [videoCall, setVideoCall] = useState(false);
  const [bithappierWallet, setBithappierWallet] = useState("");
  const [isProfileComplete, setIsProfileComplete] = useState(false);
  const [profileCompletePercentage, setProfileCompletePercentage] = useState(0);
  const [walletBallance, setWalletBallance] = useState("");
  const [usdAmount, setUsdAmount] = useState("");
  const [todayMentalHappinessResponse, setTodayMentalHappinessResponse] =
    useState(false);
  const [rtcProps, setRtcProps] = useState({
    appId: "",
    channel: "",
    token: "",
  });

  const navigate = useNavigate();
  const cookies = new Cookies();
  const token = cookies.get("isLoggedIn", { path: "/" });
  let accountId;
  if (localStorage.near_app_wallet_auth_key) {
    accountId = JSON.parse(localStorage.near_app_wallet_auth_key).accountId;
    // console.log(accountId);
  }
  const fetchWalletBalance = async (walletName) => {
    // console.log("fetch wallet balance");
    const { connect, keyStores, WalletConnection } = nearAPI;
    let account;
    // const connectionConfig = {
    //   networkId: "testnet",
    //   keyStore: new keyStores.BrowserLocalStorageKeyStore(),
    //   nodeUrl: "https://rpc.testnet.near.org",
    //   walletUrl: "https://wallet.testnet.near.org",
    //   helperUrl: "https://helper.testnet.near.org",
    //   explorerUrl: "https://explorer.testnet.near.org",
    // };
    const connectionConfig = {
      networkId: process.env.REACT_APP_NEAR_NETWORK,
      keyStore: new keyStores.BrowserLocalStorageKeyStore(), // first create a key store
      nodeUrl: `https://rpc.${process.env.REACT_APP_NEAR_NETWORK}.near.org`,
      walletUrl: process.env.REACT_APP_NEAER_WALLET_URL,
      helperUrl: `https://helper.${process.env.REACT_APP_NEAR_NETWORK}.near.org`,
      explorerUrl: `https://explorer.${process.env.REACT_APP_NEAR_NETWORK}.near.org`,
    };
    // bithappiert.testnet
    const nearConnection = await connect(connectionConfig);
    if (accountId) {
      account = await nearConnection.account(walletName);
    } else {
      account = await nearConnection.account(
        `${walletName}.${process.env.REACT_APP_NEAR_WALLET_SUFFIX}`
      );
    }
    const balance = await account.getAccountBalance();
    //parse function
    // converts yoctoNEAR (10^-24) amount into NEAR

    const { utils } = nearAPI;

    console.log("Full balance:", balance);

    const amountInNEAR = utils.format.formatNearAmount(balance.total);

    console.log("wallet balance:", amountInNEAR);

    setWalletBallance(Number(amountInNEAR).toFixed(5));
    // const amountInNEAR = utils.format.formatNearAmount(balance.available, 4);
    // console.log("wallet balance4", amountInNEAR);
    // if (amountInNEAR.includes(".")) {
    //   let pontArry = amountInNEAR.split(".");
    //   console.log(pontArry)
    //   setWalletBallance(pontArry[0] + "." + pontArry[1].slice(0, 2));
    // } else {
    //   setWalletBallance(amountInNEAR);
    // }
  };

  useEffect(() => {
    axios.get(`${APIURI}api/user/get-near-usd`, apiConfig).then((res) => {
      setUsdAmount(res.data.data);
    });
  }, [loggedIn]);

  useEffect(() => {
    if (accountId) {
      fetchWalletBalance(accountId);
    }
    axios.get(`${APIURI}user-detail/profile`, apiConfig).then((res) => {
      console.log(res);
      if (res.data.username) {
        setUserName(res.data.username);
        cookies.set("username", res.data.username);
      }
      if (res.data.image) {
        setProfileImage(res.data.image);
      }
      if (res.data.walletName) {
        fetchWalletBalance(res.data.walletName);
      }
      setBithappierWallet(res.data.walletName);
      cookies.set("walletName", res.data.walletName);
      setIsProfileComplete(res.data.completeProfile);
      setTodayMentalHappinessResponse(res.data.getMentalhappiness);
      setProfileCompletePercentage(res.data.profileCompleted);
      cookies.set("userId", res.data.userId);
      cookies.set("therapistId", res.data.profileId)
    });
  }, [loggedIn]);

  // // Function to get user IP address
  // useEffect(() => {
  //   const getUserIP = async () => {
  //     try {
  //       const response = await axios.get("https://api64.ipify.org?format=json");
  //       const ipAddress = response.data.ip;
  //       console.log(`here we get user's IP address: `, ipAddress);
  //     } catch (error) {
  //       console.error("Error fetching IP address:", error);
  //     }
  //   };
  //   // Get the user's IP address
  //   getUserIP();
  // }, []);

  useEffect(() => {
    if (cookies.get("isFirstTimeLogin", { path: "/" })) {
      navigate("/editpassword");
    }
  }, []);

  return (
    <>
      {/* <Navbarheader/> */}
      {/* <Router> */}
      <usdAmountContext.Provider value={[usdAmount, setUsdAmount]}>
        <ProfileImageContext.Provider value={[profileImage, setProfileImage]}>
          <userNameContext.Provider value={[userName, setUserName]}>
            <videoCallContext.Provider value={[videoCall, setVideoCall]}>
              <rtcPropsContext.Provider value={[rtcProps, setRtcProps]}>
                <bithappierWalletContext.Provider
                  value={[bithappierWallet, setBithappierWallet]}
                >
                  <mentalHappinessResponseContext.Provider
                    value={[
                      todayMentalHappinessResponse,
                      setTodayMentalHappinessResponse,
                    ]}
                  >
                    <isProfileCompleteContext.Provider
                      value={[isProfileComplete, setIsProfileComplete]}
                    >
                      <LogInCall.Provider value={[loggedIn, setLoggedIn]}>
                        <completePercentageContext.Provider
                          value={[
                            profileCompletePercentage,
                            setProfileCompletePercentage,
                          ]}
                        >
                          <walletBalanceContext.Provider
                            value={[walletBallance, setWalletBallance]}
                          >
                            {/* <Route exact path='/' element={<Home/>} />
        <Route exact path='/tokenomics' element={<Tokenomics/>} />
        <Route exact path='/privacypolicypage' element={<PrivacyPolicy/>} /> */}
                            <Suspense
                              fallback={
                                <div className="d-flex justify-content-center align-items-center min-h-100vh">
                                  {" "}
                                  <RotatingLines
                                    strokeColor="#d9567a"
                                    strokeWidth="5"
                                    animationDuration="0.75"
                                    width="96"
                                    visible={true}
                                  />
                                </div>
                              }
                            >
                              {token ? (
                                <Routes>
                                  <Route
                                    exact
                                    path="/dashboard"
                                    element={<Dashboard />}
                                  />
                                  <Route
                                    exact
                                    path="/buy-near"
                                    element={<BuyNear />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessBlogs"
                                    element={<AllHappinessBlogs />}
                                  />
                                  <Route
                                    exact
                                    path="/meetups"
                                    element={<MeetUp />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessNews"
                                    element={<AllHappinessNews />}
                                  />
                                  <Route
                                    exact
                                    path="/checkout/:id"
                                    element={<Index />}
                                  />
                                  <Route
                                    exact
                                    path="/buy-near-via-stripe"
                                    element={<BuyNearViaStripe />}
                                  />
                                  <Route
                                    exact
                                    path="/book-appointment/stipe-payment"
                                    element={<BookAppointmentViaStripe />}
                                  />
                                  <Route
                                    exact
                                    path="/transactioncomplete"
                                    element={<SuccessPage />}
                                  />
                                  <Route
                                    exact
                                    path="/transactioncomplete-corporate"
                                    element={<PaymentConfirmation />}
                                  />
                                  <Route
                                    exact
                                    path="/mridata"
                                    element={<MriData />}
                                  />
                                  <Route
                                    exact
                                    path="/homehappinessnews"
                                    element={<HomeHappinessNews />}
                                  />
                                  <Route
                                    exact
                                    path="/verifyotp"
                                    element={<VerifyOtp />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessmeetup"
                                    element={<HappinessMeetupCard />}
                                  />

                                  <Route
                                    exact
                                    path="/selfhelp"
                                    element={<SelfHelp />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessrecommendation"
                                    element={<HappinessRecommendation />}
                                  />
                                  <Route
                                    exact
                                    path="/reward"
                                    element={<RewardPage />}
                                  />
                                  <Route
                                    exact
                                    path="/redeemreward"
                                    element={<RedeemRewardPage />}
                                  />
                                  <Route
                                    exact
                                    path="/wallet/import/:id"
                                    element={<WalletImportThroughEmail />}
                                  />
                                  <Route
                                    exact
                                    path="/fitbit"
                                    element={<Fitbit />}
                                  />
                                  <Route
                                    exact
                                    path="/corporatedashboard"
                                    element={<CorporateDashboard />}
                                  />
                                  <Route
                                    exact
                                    path="survey"
                                    element={<SelectPreferredSurvey />}
                                  />
                                  <Route
                                    exact
                                    path="feedback"
                                    element={<GroupSessionFeedback />}
                                  />
                                  <Route
                                    exact
                                    path="afterfeedback"
                                    element={<AfterSessionFeedback />}
                                  />
                                  <Route
                                    exact
                                    path="cbthelp"
                                    element={<CBTHelp />}
                                  />
                                  <Route
                                    exact
                                    path="cbthelp/:id"
                                    element={<CBTHelpDyanmic />}
                                  />
                                  <Route
                                    exact
                                    path="cbthelp/:id/:subId"
                                    element={<SelfcareCardPage />}
                                  />
                                  {/* <Route
                                    exact
                                    path="explore"
                                    element={<Explore />}
                                  />
                                  <Route
                                    exact
                                    path="explore/:id"
                                    element={<ExploreDynamic />}
                                  />
                                  <Route
                                    exact
                                    path="explore/:id/:subId"
                                    element={<ExploreSelfcareDynamic />}
                                  /> */}
                                  <Route
                                    exact
                                    path="questionnaire"
                                    element={<Questionnaire />}
                                  />
                                  <Route
                                    exact
                                    path="selfcare"
                                    element={<SelfCare />}
                                  />
                                  <Route
                                    exact
                                    path="breathingexercise"
                                    element={<BreathingExercise />}
                                  />
                                  <Route
                                    exact
                                    path="progressivemusclerelaxation"
                                    element={<ProgressiveMuscleRelaxation />}
                                  />
                                  <Route
                                    exact
                                    path="imageryexercise"
                                    element={<ImageryExercise />}
                                  />
                                  <Route
                                    exact
                                    path="thought"
                                    element={<Thought />}
                                  />
                                  <Route
                                    exact
                                    path="behaviour"
                                    element={<Behaviour />}
                                  />
                                  <Route
                                    exact
                                    path="unhelpfulthinkingstyle"
                                    element={<UnhelpfulThinkingStyle />}
                                  />
                                  <Route
                                    exact
                                    path="psychoeducation"
                                    element={<Psychoeducation />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessprofile"
                                    element={
                                      <happinessResChange.Provider
                                        value={[
                                          happinessResChan,
                                          setHappinessResChan,
                                        ]}
                                      >
                                        {" "}
                                        <HappinessProfile />{" "}
                                      </happinessResChange.Provider>
                                    }
                                  />
                                  <Route
                                    exact
                                    path="/mricenter"
                                    element={<Mricenters />}
                                  />
                                  {/* <Route exact path="/fitnessdata" element={<Fitnessdata/>}/> */}
                                  <Route
                                    exact
                                    path="/connectwallet"
                                    element={<Conncetwallet />}
                                  />
                                  <Route
                                    exact
                                    path="/fororganization"
                                    element={<ForOrganizations />}
                                  />
                                  <Route
                                    exact
                                    path="/createwallet"
                                    element={<Createwallet />}
                                  />
                                  <Route
                                    exact
                                    path="/existwallet"
                                    element={<Existwallet />}
                                  />
                                  <Route
                                    exact
                                    path="/buybht"
                                    element={<BuyBHT />}
                                  />
                                  <Route
                                    exact
                                    path="/stakebht"
                                    element={<StakeBHT />}
                                  />
                                  <Route
                                    exact
                                    path="/stakebhtsummary"
                                    element={<StakeBTHSummary />}
                                  />
                                  <Route
                                    exact
                                    path="/walletauthorisation"
                                    element={<WalletAuthorisation />}
                                  />
                                  <Route
                                    exact
                                    path="/congrats"
                                    element={<Congrats />}
                                  />
                                  <Route
                                    exact
                                    path="/smileres"
                                    element={<Smileres />}
                                  />
                                  <Route
                                    exact
                                    path="/recordinput"
                                    element={<Recordinput />}
                                  />
                                  <Route
                                    exact
                                    path="/forgetpasswordphase1"
                                    element={<ForgetPasswordPhase1 />}
                                  />
                                  <Route
                                    exact
                                    path="/forgetpasswordphase2"
                                    element={<ForgetPasswordPhase2 />}
                                  />
                                  <Route
                                    exact
                                    path="/verifyemail"
                                    element={<VerifyEmail />}
                                  />
                                  <Route
                                    exact
                                    path="/paymentgateway"
                                    element={<PaymentGateway />}
                                  />
                                  <Route
                                    exact
                                    path="/seeyourresult"
                                    element={<SeeYourResult />}
                                  />
                                  <Route
                                    exact
                                    path="/inputassessment"
                                    element={<Inputassessment />}
                                  />
                                  {/* <Route exact path='/userprofile' element={<UserProfile/>}/> */}
                                  <Route
                                    exact
                                    path="/wallet"
                                    element={<WalletPage />}
                                  />
                                  <Route
                                    exact
                                    path="/recomendedcards"
                                    element={<RecomendedCards />}
                                  />
                                  <Route
                                    exact
                                    path="/community"
                                    element={<Community />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessnewsdetail/:id"
                                    element={<HappinessNewsdetail />}
                                  />
                                  <Route
                                    exact
                                    path="/latestthread"
                                    element={<Latestthread />}
                                  />
                                  <Route
                                    exact
                                    path="/communitydetail/threads::id"
                                    element={<Communitydetail />}
                                  />
                                  <Route
                                    exact
                                    path="/popular"
                                    element={<Popular />}
                                  />
                                  <Route
                                    exact
                                    path="/homepage"
                                    element={<Homepage />}
                                  />
                                  <Route
                                    exact
                                    path="/goaldetail/goals/:id"
                                    element={
                                      <happinessGoalChange.Provider
                                        value={[
                                          happinessGoalChan,
                                          setHappinessGoalChan,
                                        ]}
                                      >
                                        {" "}
                                        <Goaldetail />{" "}
                                      </happinessGoalChange.Provider>
                                    }
                                  />
                                  <Route
                                    exact
                                    path="/most_read_thread"
                                    element={<Most_thread />}
                                  />
                                  <Route
                                    exact
                                    path="/mostliked_thread"
                                    element={<Most_Liked />}
                                  />
                                  <Route
                                    exact
                                    path="/publicProfile/user/:id"
                                    element={
                                      <followersChange.Provider
                                        value={[
                                          followersChan,
                                          setFollowersChan,
                                        ]}
                                      >
                                        {" "}
                                        <PublicProfilePage />{" "}
                                      </followersChange.Provider>
                                    }
                                  />
                                  <Route
                                    exact
                                    path="/happinessContent"
                                    element={<HappinessContent />}
                                  />
                                  <Route
                                    exact
                                    path="/myprofile"
                                    element={<Myprofile />}
                                  />
                                  <Route
                                    exact
                                    path="/practitioner"
                                    element={<Practitioners />}
                                  />
                                  <Route
                                    exact
                                    path="/leaderboard"
                                    element={<LeaderBoard />}
                                  />
                                  <Route
                                    exact
                                    path="/allarttherapist/:id"
                                    element={<AllArttherapist />}
                                  />
                                  <Route
                                    exact
                                    path="/practitionerdetails/:id"
                                    element={<PractitionersDetails />}
                                  />
                                  <Route
                                    exact
                                    path="/practitioner/bookappointment/:id"
                                    element={<BookAppointment />}
                                  />
                                  <Route
                                    exact
                                    path="/yourappointments"
                                    element={<YourAppointments />}
                                  />
                                  <Route
                                    exact
                                    path="/notification"
                                    element={<Notification />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/journalling"
                                    element={<Journalling />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/psychotherapy"
                                    element={<Psychotherapy />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/physicalActivity"
                                    element={<PhysicalActivity />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/artgallery"
                                    element={<ArtGallery />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/buyingart"
                                    element={<BuyingArt />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/digitaldetox"
                                    element={<DigitalDetox />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/walking"
                                    element={<Walking />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/goalsetting"
                                    element={<GoalSetting />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/sleep"
                                    element={<Sleep />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/familytherapy"
                                    element={<FamilyTherapy />}
                                  />
                                  <Route
                                    exact
                                    path="/recommendedactivity/positiveatituted"
                                    element={<PositiveAttitude />}
                                  />
                                  <Route
                                    exact
                                    path="/editpassword"
                                    element={<EditPassword />}
                                  />
                                  <Route
                                    exact
                                    path="/marketplace"
                                    element={<Marketplace />}
                                  />
                                  <Route
                                    exact
                                    path="/exploremarketplace/:id"
                                    element={<ExploreMarketplace />}
                                  />
                                  <Route
                                    exact
                                    path="/startvideocall/channel/:id"
                                    element={<VideoCall />}
                                  />
                                  <Route
                                    exact
                                    path="/startvideocall/therapist/channel/:id"
                                    element={<VideoCallTherapist />}
                                  />

                                  {/* <Route exact path="/sidebars" element={<Sidebar/>} /> */}

                                  <Route
                                    exact
                                    path="/digitalauction"
                                    element={<DigitalAuction />}
                                  />
                                  <Route
                                    exact
                                    path="/physicaldirectsale"
                                    element={<PhysicalDirectSale />}
                                  />
                                  <Route
                                    exact
                                    path="/shippingaddressdetails/:id"
                                    element={<ShippingAddress />}
                                  />
                                  <Route
                                    exact
                                    path="/confirmaddress"
                                    element={<ConfirmAddress />}
                                  />
                                  <Route
                                    exact
                                    path="/directlist"
                                    element={<DirectList />}
                                  />
                                  <Route
                                    exact
                                    path="/professionaldashboard"
                                    element={<ProfessionalDashboard />}
                                  />
                                  <Route
                                    exact
                                    path="/myprofile"
                                    element={<MyProfilePractitionres />}
                                  />

                                  <Route
                                    exact
                                    path=""
                                    element={
                                      <>
                                        <HomeV2 />
                                      </>
                                    }
                                  />
                                  <Route
                                    exact
                                    path="/assessment"
                                    element={<Assessment />}
                                  />
                                  {/* <Route
                                    exact
                                    path="/questionire"
                                    element={<Questionaire />}
                                  /> */}
                                  <Route
                                    exact
                                    path="/t&c"
                                    element={<Termsandcondition />}
                                  />
                                  <Route
                                    exact
                                    path="/delete-your-account"
                                    element={<DeleteYourAccount />}
                                  />
                                  <Route
                                    exact
                                    path="/privacypolicy"
                                    element={<Privacypolicy />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessresearch"
                                    element={<Happinessresearch />}
                                  />
                                  <Route
                                    exact
                                    path="/demo"
                                    element={<Demo />}
                                  />
                                  <Route
                                    exact
                                    path="/aboutus"
                                    element={<AboutUsPage />}
                                  />
                                  <Route exact path="/faq" element={<Faq />} />
                                  <Route exact path="/contact-us" element={<ContactUs />} />

                                  <Route
                                    exact
                                    path="/login"
                                    element={
                                      <LogInCall.Provider
                                        value={[loggedIn, setLoggedIn]}
                                      >
                                        <Login />
                                      </LogInCall.Provider>
                                    }
                                  />
                                  <Route
                                    exact
                                    path="/viewQEEGReport/:id"
                                    element={
                                      <LogInCall.Provider
                                        value={[loggedIn, setLoggedIn]}
                                      >
                                        <OpenReport />
                                      </LogInCall.Provider>
                                    }
                                  />
                                  <Route
                                    exact
                                    path="/signup"
                                    element={<Signup />}
                                  />
                                  <Route
                                    exact
                                    path="/crisishelpline"
                                    element={<CrisisHelpline />}
                                  />
                                  <Route
                                    exact
                                    path="/wellnessprofessionaljoin"
                                    element={<WellNessProfessionalJoin />}
                                  />
                                  <Route
                                    exact
                                    path="/tokenomics"
                                    element={<Tokenomics />}
                                  />
                                  {/* check once all router */}
                                  <Route
                                    exact
                                    path="/adminconsole"
                                    element={<AdminConsole />}
                                  />
                                  <Route
                                    exact
                                    path="/Admindashboard"
                                    element={<AdminDashboard />}
                                  />
                                  <Route
                                    exact
                                    path="/enjoyarttherapy"
                                    element={<EnjoyArtTherapypage />}
                                  />
                                  <Route
                                    exact
                                    path="/therapymemberlist"
                                    element={<TherapyMemberList />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessrecommendation"
                                    element={<HappinessRecommendation />}
                                  />
                                  <Route
                                    exact
                                    path="/reward"
                                    element={<RewardPage />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessmeetup"
                                    element={<HappinessMeetupCard />}
                                  />
                                  <Route
                                    exact
                                    path="/selfhelp"
                                    element={<SelfHelp />}
                                  />
                                  <Route
                                    exact
                                    path="/redeemreward"
                                    element={<RedeemRewardPage />}
                                  />
                                  <Route
                                    exact
                                    path="/adminconsole"
                                    element={<AdminConsole />}
                                  />
                                  <Route
                                    exact
                                    path="/Admindashboard"
                                    element={<AdminDashboard />}
                                  />
                                  <Route
                                    exact
                                    path="/corporatedashboard"
                                    element={<CorporateDashboard />}
                                  />
                                  <Route
                                    exact
                                    path="survey"
                                    element={<SelectPreferredSurvey />}
                                  />
                                  <Route
                                    exact
                                    path="feedback"
                                    element={<GroupSessionFeedback />}
                                  />
                                  <Route
                                    exact
                                    path="afterfeedback"
                                    element={<AfterSessionFeedback />}
                                  />
                                  <Route
                                    exact
                                    path="cbthelp"
                                    element={<CBTHelp />}
                                  />
                                  <Route
                                    exact
                                    path="cbthelp/:id"
                                    element={<CBTHelpDyanmic />}
                                  />
                                  <Route
                                    exact
                                    path="questionnaire"
                                    element={<Questionnaire />}
                                  />
                                  <Route
                                    exact
                                    path="cbthelp/:id/:subId"
                                    element={<SelfcareCardPage />}
                                  />
                                  <Route
                                    exact
                                    path="selfcare"
                                    element={<SelfCare />}
                                  />
                                  <Route
                                    exact
                                    path="breathingexercise"
                                    element={<BreathingExercise />}
                                  />
                                  <Route
                                    exact
                                    path="progressivemusclerelaxation"
                                    element={<ProgressiveMuscleRelaxation />}
                                  />
                                  <Route
                                    exact
                                    path="imageryexercise"
                                    element={<ImageryExercise />}
                                  />
                                  <Route
                                    exact
                                    path="thought"
                                    element={<Thought />}
                                  />
                                  <Route
                                    exact
                                    path="unhelpfulthinkingstyle"
                                    element={<UnhelpfulThinkingStyle />}
                                  />
                                  <Route
                                    exact
                                    path="behaviour"
                                    element={<Behaviour />}
                                  />
                                  <Route
                                    exact
                                    path="psychoeducation"
                                    element={<Psychoeducation />}
                                  />
                                  <Route
                                    exact
                                    path="/questionire"
                                    element={<Questionaire />}
                                  />
                                  <Route
                                    exact
                                    path="/appointmentconfirmation"
                                    element={<AppointmentConfirmationPage />}
                                  />
                                  <Route
                                    exact
                                    path="/aichatbot"
                                    element={<AiChatbot />}
                                  />
                                  <Route
                                    exact
                                    path="corporateaddmember"
                                    element={<CorporateAddMember />}
                                  />
                                  <Route
                                    exact
                                    path="subscription"
                                    element={<Subscription />}
                                  />
                                </Routes>
                              ) : (
                                <Routes>
                                  <Route
                                    exact
                                    path=""
                                    element={
                                      <>
                                        <HomeV2 />
                                      </>
                                    }
                                  />
                                  <Route
                                    exact
                                    path="/happinessBlogs"
                                    element={<AllHappinessBlogs />}
                                  />
                                  <Route
                                    exact
                                    path="/meetups"
                                    element={<MeetUp />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessNews"
                                    element={<AllHappinessNews />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessnewsdetail/:id"
                                    element={<HappinessNewsdetail />}
                                  />
                                  <Route
                                    exact
                                    path="/verifyotp"
                                    element={<VerifyOtp />}
                                  />
                                  <Route
                                    exact
                                    path="/forgetpasswordphase1"
                                    element={<ForgetPasswordPhase1 />}
                                  />
                                  <Route
                                    exact
                                    path="/forgetpasswordphase2"
                                    element={<ForgetPasswordPhase2 />}
                                  />
                                  <Route
                                    exact
                                    path="/verifyemail"
                                    element={<VerifyEmail />}
                                  />
                                  <Route exact path="/faq" element={<Faq />} />
                                  <Route exact path="/contact-us" element={<ContactUs />} />

                                  <Route
                                    exact
                                    path="/homehappinessnews"
                                    element={<HomeHappinessNews />}
                                  />
                                  <Route
                                    exact
                                    path="/demo"
                                    element={<Demo />}
                                  />
                                  <Route
                                    exact
                                    path="/tokenomics"
                                    element={<Tokenomics />}
                                  />
                                  <Route
                                    exact
                                    path="/login"
                                    element={
                                      <LogInCall.Provider
                                        value={[loggedIn, setLoggedIn]}
                                      >
                                        <Login />
                                      </LogInCall.Provider>
                                    }
                                  />
                                  <Route
                                    exact
                                    path="/viewQEEGReport/:id"
                                    element={
                                      <LogInCall.Provider
                                        value={[loggedIn, setLoggedIn]}
                                      >
                                        <OpenReport />
                                      </LogInCall.Provider>
                                    }
                                  />
                                  <Route
                                    exact
                                    path="/signup"
                                    element={<Signup />}
                                  />
                                  <Route
                                    exact
                                    path="/assessment"
                                    element={<Assessment />}
                                  />
                                  <Route
                                    exact
                                    path="/questionire"
                                    element={<Questionaire />}
                                  />
                                  <Route
                                    exact
                                    path="/t&c"
                                    element={<Termsandcondition />}
                                  />
                                  <Route
                                    exact
                                    path="/delete-your-account"
                                    element={<DeleteYourAccount />}
                                  />
                                  <Route
                                    exact
                                    path="/privacypolicy"
                                    element={<Privacypolicy />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessresearch"
                                    element={<Happinessresearch />}
                                  />
                                  <Route
                                    exact
                                    path="/aboutus"
                                    element={<AboutUsPage />}
                                  />
                                  <Route
                                    exact
                                    path="/fundraiser"
                                    element={<Fundraiser />}
                                  />
                                  <Route
                                    exact
                                    path="/tickets"
                                    element={<Ticket />}
                                  />
                                  <Route
                                    exact
                                    path="/leaderboard"
                                    element={<LeaderBoard />}
                                  />
                                  <Route exact path="*" element={<HomeV2 />} />
                                  <Route
                                    exact
                                    path="/crisishelpline"
                                    element={<CrisisHelpline />}
                                  />
                                  <Route
                                    exact
                                    path="/wellnessprofessionaljoin"
                                    element={<WellNessProfessionalJoin />}
                                  />
                                  <Route
                                    exact
                                    path="/fororganization"
                                    element={<ForOrganizations />}
                                  />
                                  <Route
                                    exact
                                    path="/corporate/login"
                                    element={<CorporateLogin />}
                                  />
                                  <Route
                                    exact
                                    path="/corporate/signup"
                                    element={<CorporateSignup />}
                                  />
                                  <Route
                                    exact
                                    path="/corporatejoinus"
                                    element={<CorporateJoinus />}
                                  />
                                  {/* <Route
                                    exact
                                    path="/adminconsole"
                                    element={<AdminConsole />}
                                  />
                                  <Route
                                    exact
                                    path="/Admindashboard"
                                    element={<AdminDashboard />}
                                  />
                                  <Route
                                    exact
                                    path="/enjoyarttherapy"
                                    element={<EnjoyArtTherapypage />}
                                  />
                                  <Route
                                    exact
                                    path="/therapymemberlist"
                                    element={<TherapyMemberList />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessrecommendation"
                                    element={<HappinessRecommendation />}
                                  />
                                  <Route
                                    exact
                                    path="/reward"
                                    element={<RewardPage />}
                                  />
                                  <Route
                                    exact
                                    path="/happinessmeetup"
                                    element={<HappinessMeetupCard />}
                                  />
                                  <Route
                                    exact
                                    path="/selfhelp"
                                    element={<SelfHelp />}
                                  />
                                  <Route
                                    exact
                                    path='/redeemreward'
                                    element={<RedeemRewardPage />}
                                  />
                                  <Route
                                    exact
                                    path="/adminconsole"
                                    element={<AdminConsole />}
                                  />
                                  <Route
                                    exact
                                    path="/Admindashboard"
                                    element={<AdminDashboard />}
                                  />
                                  <Route
                                    exact
                                    path="/corporatedashboard"
                                    element={<CorporateDashboard />}
                                  />
                                  <Route
                                    exact
                                    path="survey"
                                    element={<SelectPreferredSurvey />}
                                  />
                                  <Route
                                    exact
                                    path="feedback"
                                    element={<GroupSessionFeedback />}
                                  />
                                  <Route
                                    exact
                                    path="cbthelp"
                                    element={<CBTHelp />}
                                  />
                                  <Route
                                    exact
                                    path="cbthelp/:id"
                                    element={<CBTHelpDyanmic />}
                                  /> */}
                                  {/* <Route
                                    exact
                                    path='questionnaire'
                                    element={<Questionnaire />}
                                  />
                                  <Route
                                    exact
                                    path="cbthelp/:id/:subId"
                                    element={<SelfcareCardPage />}
                                  />
                                  <Route
                                    exact
                                    path="selfcare"
                                    element={<SelfCare />}
                                  />
                                  <Route
                                    exact
                                    path="breathingexercise"
                                    element={<BreathingExercise />}
                                  />
                                  <Route
                                    exact
                                    path="progressivemusclerelaxation"
                                    element={<ProgressiveMuscleRelaxation />}
                                  />
                                  <Route
                                    exact
                                    path="imageryexercise"
                                    element={<ImageryExercise />}
                                  />
                                  <Route
                                    exact
                                    path='thought'
                                    element={<Thought />}
                                  />
                                  <Route
                                    exact
                                    path="unhelpfulthinkingstyle"
                                    element={<UnhelpfulThinkingStyle />}
                                  />
                                  <Route
                                    exact
                                    path='behaviour'
                                    element={<Behaviour />}
                                  />
                                  <Route
                                    exact
                                    path='psychoeducation'
                                    element={<Psychoeducation />}
                                  />*/}
                                </Routes>
                              )}
                            </Suspense>
                          </walletBalanceContext.Provider>
                        </completePercentageContext.Provider>
                      </LogInCall.Provider>
                    </isProfileCompleteContext.Provider>
                  </mentalHappinessResponseContext.Provider>
                </bithappierWalletContext.Provider>
              </rtcPropsContext.Provider>
            </videoCallContext.Provider>
          </userNameContext.Provider>
        </ProfileImageContext.Provider>
      </usdAmountContext.Provider>
      {/* </Router> */}
    </>
  );
}

export default App;
